import BillingRecoveryScreen from '../../src/screens/auth/BillingRecoveryScreen';

export default BillingRecoveryScreen;
